import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { useWindowSize } from "react-use";
import Collapse from "../../Components/base/Collapse";
import Icon from "../../Components/base/Icon";
import AuthContext from "../../Contexts/authContext";
import ThemeContext from "../../Contexts/themeContext";
import { REACT_APP_MOBILE_BREAKPOINT_SIZE } from "../../Utils/Constant";
import { setUser } from "../../Store/Readux/Reducer/GlobalSlice";
import { profileMenu } from "../../menu";
import ApiConstants from "../../Utils/ApiConstant";
import Avatar from "../../Components/base/Avatar";
import { Userlogout } from "../../Services/AuthServices";
import { useDispatch } from "react-redux";

const User = () => {
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const avatarIcon = "/assets/images/avatar.png";
  const { setAsideStatus } = useContext(ThemeContext);
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
  const [collapseStatus, setCollapseStatus] = useState(false);
  const storedUser = localStorage.getItem("user");
  const user = storedUser && storedUser !== "undefined" ? JSON.parse(storedUser) : null;
  // const handleItem = useNavigationItemHandle();

  const profilePath = `${ApiConstants.profileUploadPath + user?.profile_image}`;
  const userImage = user?.profile_image ? profilePath : avatarIcon;
  const logoutUser = async () => {
   
    const response = await dispatch(Userlogout());
     if (response?.status_code === 200) 
    {
      setUser(null);
      localStorage.removeItem("user");
      navigate(`/login`);
    }
  }
  return (
    <>
      <div
        className={classNames("user mt-2", { open: collapseStatus })}
        role="presentation"
        onClick={() => setCollapseStatus(!collapseStatus)}
      >
        <div className="user-avatar">
          <Avatar
            src={userImage}
            avatarIcon={avatarIcon}
            width={128}
            height={128}
          />
        </div>
        <div className="user-info">
          <div className="user-name d-flex align-items-center">
            {user?.first_name} {user?.last_name}
          </div>
          <div className="user-sub-title">{user?.role?.name}</div>
        </div>
      </div>

      <Collapse isOpen={collapseStatus} className="user-menu">
        {/* <NavigationLine /> */}
        <nav aria-label="aside-bottom-user-menu-2">
          <div className="navigation">
            {/** Profile */}
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() =>
                navigate(
                  `../${profileMenu.profile.path}`
                  // @ts-ignore
                  // handleItem()
                )
              }
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon iconName="SquareUser" className="navigation-icon" />
                  <span className="navigation-text">{"Profile"}</span>
                </span>
              </span>
            </div>

            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() => {
                if (isAuthenticated) {
                 
                  setIsAuthenticated(false);
                }
                if (width < Number(REACT_APP_MOBILE_BREAKPOINT_SIZE)) {
                  setAsideStatus(false);
                }
                setUser(null);
                logoutUser();
                
              }}
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon iconName="LogOut" className="navigation-icon" />
                  <span className="navigation-text">{"Logout"}</span>
                </span>
              </span>
            </div>
          </div>
        </nav>
      </Collapse>
    </>
  );
};

export default User;
